import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";

// redux
import { getHeaderVisibility, getDarkHeader } from "frontend/store/layout";

// components
import SiteHeader from "core/SiteHeader";

// SiteHeaderParent is used on all NEW pages.
const SiteHeaderParent = ({ currentPage, ssrCookies = {} }) => {
    const isDarkMode = useSelector(getDarkHeader);
    const isVisible = useSelector(getHeaderVisibility);
    if (!isVisible) return null;
    return (
        <SiteHeader
            isDarkMode={isDarkMode}
            hasDedlayedSecondRow={isDarkMode}
            currentPage={currentPage}
            ssrCookies={ssrCookies}
        />
    );
};

export default SiteHeaderParent;

// prop-types
SiteHeaderParent.propTypes = {
    currentPage: PropTypes.string,
    ssrCookies: PropTypes.object
};
